import { Link, Stack } from '@mui/material';
import { t } from 'i18next';
import HelpPopover, { HelpPopoverText } from '../../../components/HelpPopover';
import { Trans } from 'react-i18next';

export const HowWePickInvestmentsModal: React.FC = () => {
  return (
    <HelpPopover title=''>
      <Stack spacing={2}>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>
          {t('HowWePickInvestments')}
        </HelpPopoverText>
        <HelpPopoverText>{t('WeSetYourTargetMixAcrossStocks')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>{t('YourChoice')}</HelpPopoverText>
        <HelpPopoverText>{t('UseOurExamplesOrSwap')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>
          {t('TellUsAboutAllTheInvestments')}
        </HelpPopoverText>
        <HelpPopoverText>{t('YoullFindThisListByLogging')}</HelpPopoverText>
      </Stack>
    </HelpPopover>
  );
};

export const SampleInvestmentMixModal: React.FC = () => {
  return (
    <HelpPopover title=''>
      <Stack spacing={2}>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>
          {t('HowWePickInvestments')}
        </HelpPopoverText>
        <HelpPopoverText>{t('WeSetYourTargetMixAcrossStocks')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>{t('YourChoice')}</HelpPopoverText>
        <HelpPopoverText>{t('UseOurExamplesOrSwap')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>
          {t('AddYourInvestmentAccounts')}
        </HelpPopoverText>
        <HelpPopoverText>{t('AsYouAddYourAccounts')}</HelpPopoverText>
      </Stack>
    </HelpPopover>
  );
};

export const UpsellInvestmentAdviceModal: React.FC = () => {
  return (
    <HelpPopover title=''>
      <Stack spacing={2}>
        <HelpPopoverText style={{ fontWeight: 'bold', textAlign: 'left' }}>
          {t('OurUseOfAgenticAI')}
        </HelpPopoverText>
        <HelpPopoverText style={{ textAlign: 'left' }}>
          {t('NickelsUsesModularGoalBased')}
        </HelpPopoverText>
        <HelpPopoverText style={{ textAlign: 'left' }} className='link-wrapper'>
          <Trans
            i18nKey='WeUseAIWhereItMatters'
            components={{
              MPT: (
                <Link
                  target='_blank'
                  rel='noopener'
                  href='https://guidedchoice.com/modern-portfolio-theory/'
                />
              ),
            }}
          />
        </HelpPopoverText>
      </Stack>
    </HelpPopover>
  );
};

export const IraBrokerageInvestmentMixModal: React.FC = () => {
  return (
    <HelpPopover title=''>
      <Stack spacing={2}>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>
          {t('HowWePickInvestments')}
        </HelpPopoverText>
        <HelpPopoverText>{t('WeSetYourTargetMixAcrossStocks')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>{t('WhatWeShow')}</HelpPopoverText>
        <HelpPopoverText>{t('ForEachAssetClassWeList')}</HelpPopoverText>
        <HelpPopoverText style={{ fontWeight: 'bold' }}>{t('YourChoice')}</HelpPopoverText>
        <HelpPopoverText>{t('InLowCostManyOptions')}</HelpPopoverText>
      </Stack>
    </HelpPopover>
  );
};
